export enum SearchResultsBlock {
  Root = 'SearchResults',
}
